import { ReactNode } from "react";

import { Alert, AlertDescription, AlertTitle } from "src/core/components/ui/alert";
import { cn } from "src/core/lib/utils";

type AlertWithIconProps = {
  icon: ReactNode;
  title: string;
  description: string;
  variant?: "default" | "destructive";
  className?: string;
};

export const AlertWithIcon = ({
  icon,
  title,
  description,
  variant = "default",
  className,
}: AlertWithIconProps) => {
  return (
    <Alert variant={variant} className={className}>
      <div className="flex flex-row items-center">
        <div
          className={cn(
            "flex items-center justify-center font-medium mr-10 border rounded-full w-[16px] h-[16px] border-red-medium text-xs bg-background-secondary",
            variant === "destructive" && "border-red-medium",
            variant === "default" && "border-foreground"
          )}
        >
          {icon}
        </div>
        <div className="flex flex-col">
          {title !== "" && <AlertTitle>{title}</AlertTitle>}
          <AlertDescription>{description}</AlertDescription>
        </div>
      </div>
    </Alert>
  );
};
